import load from 'little-loader';

let sdk;
let sdkLoading = false;

const trackQueue = [];
const defaultSdkCDN = 'https://jssdk.pulse.schibsted.com/autoTracker.with-engage.min.js';

const getArticleEngageOpts = (params) => ({
    articleId: params.content.id,
    title: params.content.title,
    category: params.content.categories && params.content.categories[0],
    group: params.content.group,
    published: params.content.published,
    updated: params.content.updated,
    authors: params.content.authors,
    wordCount: params.content.wordcount,
    shareUrl: {
        facebook: params.url,
    },
});

// convert from derp format to pulses actual data format
const convert = (params) => {
    const customPulse = params.custom ? params.custom.pulse : {};

    const articleEngage = params.type === 'Article' || params.type === 'SalesPoster'; // TODO: check that salesposter is correct here
    const pageEngage = false; // params.type === 'Listing';

    let engageOpts;
    if (articleEngage || pageEngage) {
        engageOpts = {
            // common engage options
            site: params.site,
            device: params.device,
            permalink: params.url,
            contentType: params.type,
            enableOverlay: params.enableOverlay,
            previewUrl: {
                http: params.url,
                https: params.url,
            },

            // add article engage options
            ...(articleEngage ? getArticleEngageOpts(params) : {}),
        };
    }

    const pulseEngageEvent = {
        clientId: params.site.toLowerCase(),
        contentId: params.content.id,
        contentType: params.type,
        category: params.content.categories && params.content.categories[0],
        tags: (params.content.tags || []).map((tag) => tag.title),
        experiments: params.experiments,
        trackingFeatures: {
            impressionTracking: articleEngage, // enable impression tracking on articles for recirc matrix
            articleEngage,
            pageEngage,
            engageOpts,
        },
        userId: params.userId,
        userIdDomain: params.userIdDomain || 'spid.no',
        object: customPulse,
        provider: {
            productTag: params.content.productTag,
        },
    };

    return pulseEngageEvent;
};

export default ({ cdn = defaultSdkCDN, trackerId = 'engage' } = {}) => ({
    track(params) {
        return new Promise((resolve, reject) => {
            if (!params) {
                return reject(new Error('Tracking params must be specified'));
            }

            const isInitialized = sdk && !sdkLoading;
            const isUninitialized = !sdk && !sdkLoading;
            const isLoading = !sdk && sdkLoading;
            const isStalled = sdk && sdkLoading;
            const sdkParams = convert(params);

            if (isInitialized) {
                params.url = window.location.href; // eslint-disable-line

                sdk.initTracking(sdkParams, true);
            } else if (isLoading) {
                params.url = window.location.href; // eslint-disable-line

                trackQueue.push(sdkParams);
            } else if (isUninitialized || isStalled) {
                sdkLoading = true;
                window.pulse2opt = sdkParams; // eslint-disable-line

                // load the autotracker script
                load(cdn, (err) => {
                    if (err) {
                        return reject(err);
                    }

                    try {
                        if (!window.AutoTrack) {
                            // eslint-disable-line
                            sdk = true;
                            throw new Error(
                                `Stalled: failed to load Pulse+Engage SDK using CDN: ${cdn}`,
                            );
                        }

                        sdk = window.AutoTrack; // eslint-disable-line

                        sdkLoading = false;
                        trackQueue.forEach((event) => sdk.initTracking(event, true));
                    } catch (trackErr) {
                        return reject(trackErr);
                    }

                    return resolve({
                        response: 'Pulse+Engage tracking completed.',
                        params,
                        trackerId,
                    });
                });
            }

            return undefined;
        });
    },
});



/** WEBPACK FOOTER **
 ** ./src/tracking/pulse-engage-tracker.js
 **/